import { AxiosResponse } from 'axios';

import { http } from '@/api/http';
import { IGetParams, IPaginatedListResponse } from '@/api/types';
import { ApiVersion } from '@/config';
import { IProperty } from '@/models';

export const PropertyEvidenceApi = {
  list: (
    params?: IGetParams,
  ): Promise<AxiosResponse<IPaginatedListResponse<IProperty>>> => {
    return http.get(`api/${ApiVersion.V1}/evidence`, {
      params,
    });
  },
};
